<nz-drawer [nzBodyStyle]="{  padding:'10px' }" [nzMaskClosable]="false" [nzWidth]="700" [nzTitle]='header'
  [nzFooter]="footerTpl" [nzClosable]="false" [nzKeyboard] [nzVisible]="visible" (nzOnClose)="close()">

  <ng-template #header>
    <div>
      <a (click)="close()" style="font-size: large;"> x </a> &nbsp;
      <span>Update Config for <b>{{ siteName }}</b> (<a
          href="https://docs.google.com/spreadsheets/d/{{siteConfig['file_id']}}" target="_blank">Google
          Sheet</a>)</span>
    </div>
  </ng-template>


  <ng-container *nzDrawerContent>
    <div class="loading-contaner" *ngIf="isLoading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>


    <form nz-form class="validate-form">
      <div nz-row class="validate-form-item" style="margin-bottom: 12px;">
        <div nz-col [nzSpan]="24" style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
          <label nz-checkbox name="selectAllValidated" [(ngModel)]="selectAllValidated" [nzDisabled]="!hasValidSheets()"
            (ngModelChange)="toggleSelectAllValidated()">
            <span>Select All</span>
          </label>
          <button nz-button class="button custom-button" type="button" [disabled]="!isAdmin || isValidatingAll"
            (click)="validateAllSheets()">
            Validate All
          </button>
        </div>
      </div>
      <ng-container *ngFor="let sheet of configSheets">
        <div nz-row class="validate-form-item">
          <div nz-col [nzSpan]="24">
            <span class="mr-2" nz-tooltip [nzTooltipTitle]="tooltipTemplate"
              [nzTooltipTitleContext]="{ $implicit: sheet }" [nzTooltipArrowPointAtCenter]="true">
              <fa-icon [icon]="faInfoCircleIcon" [styles]="{ color: '#3a4a5a' }" size="lg"></fa-icon>
            </span>
            <button [disabled]="!isAdmin" nz-button class="button custom-button mr-2" (click)="validateSheet(sheet)">
              Validate
            </button>
            <label nz-checkbox [name]="'sheet-' + sheet.id" [(ngModel)]="sheet.isChecked"
              [nzDisabled]="!(sheet.valid && sheet.redo)" (ngModelChange)="checkChange()">
              <span>{{sheet.name}}
              </span>
            </label>
            <!-- <span>(last update at:{{sheet.updated_at | date:'medium'}})</span> -->


            <fa-icon *ngIf="sheet.valid" [icon]="faCheckIcon" [styles]="{ color: 'green' }" size="lg"></fa-icon>
            <fa-icon *ngIf="!(sheet.valid)" [icon]="faCloseIcon" [styles]="{ color: 'red' }" size="lg"></fa-icon>
            <span *ngIf="showUpdateSchemaBtn" class="ml-2 db-btn" (click)="updateSchema(sheet)">
              <fa-icon [icon]="faDatabaseIcon" [styles]="{ color: '#3a4a5a' }" size="lg"></fa-icon>
            </span>

          </div>
        </div>
      </ng-container>
      <ng-template #tooltipTemplate let-sheet>
        <div>
          <div>Updated at: {{ sheet.updated_at | date:'medium' }}</div>
          <div>Updated by: {{ sheet.updated_by }}</div>
          <div class="text-center">---</div>
          <div>Validated at: {{ sheet.validated_at?(sheet.validated_at | date:'medium'):'-' }}</div>
          <div>Validated by: {{ sheet.validated_by?sheet.validated_by:'-' }}</div>
        </div>
      </ng-template>
      <!-- <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="master">
            <span>Master Sheet</span>
          </label>
          <button nz-button class="button custom-button">
            Validate
          </button>
        </div>
      </div>
      <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="smbs">
            <span>SMB Sheet</span>
          </label>
          <button nz-button class="button custom-button">
            Validate
          </button>
        </div>
      </div>
      <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="strings">
            <span>Strings Sheet</span>
          </label>
          <button nz-button class="button custom-button">
            Validate
          </button>
        </div>
      </div>
      <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="degradation">
            <span>Degradation Sheet</span>
          </label>
          <button nz-button class="button custom-button">
            Validate
          </button>
        </div>
      </div> -->
      <!-- <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="maps_coordinates">
            <span>map Coardinates</span>
          </label>
          <button nz-button class="button custom-button">
            Validate
          </button>
        </div>
      </div> -->
      <!-- <div nz-row class="validate-form-item">
        <div nz-col [nzSpan]="12">
          <button nz-button class="button custom-button">
            Update Config
          </button>
        </div>
      </div> -->
    </form>
    <ul style="color: #ef8081;">
      <li>Google sheet columns order should not be changed.</li>
      <li><b>"Update Config"</b> button will be enabled only after validating all sheets.</li>
      <li>After updating a sheet in the google sheets, must validate the same sheet here.</li>
      <li>Select validated sheets and click on <b>"Update Config"</b> to save configurations.</li>
    </ul>
  </ng-container>

  <ng-template #footerTpl>
    <div style="float: right">
      <button nz-button class="button custom-button" style="margin-right: 8px;" (click)="updateCMMS()">Update
        CMMS</button>
      <button nz-button class="button custom-button" style="margin-right: 8px;" (click)="close()">Cancel</button>
      <button nz-button class="button custom-button" *ngIf="isAdmin" (click)="submitForm()"
        [disabled]="!enableBtn">Update Config</button>
    </div>
  </ng-template>


</nz-drawer>